import { forwardRef, type Ref, type SVGProps } from "react";

function SvgInstantPayGraySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={52} height={52} fill="none" {...props}>
      <path
        fill="#B4BECD"
        d="M32.969 10.865c.462-1.724-1.379-2.413-2.413-1.38L15.59 26.626c-.69 1.034 0 2.757 1.379 2.757h7.238c.345 0 .477.371.345.69-1.724 4.136-3.792 11.03-3.792 11.03-.487 1.82 1.283 2.509 2.517 1.275l14.519-16.346c.69-1.034.084-2.853-1.38-2.853h-6.694c-.57 0-.804-.198-.615-.764 1.379-4.137 3.863-11.55 3.863-11.55"
      />
      <path
        fill="#D9E1EE"
        d="M30.65 10.865c.462-1.724-1.378-2.413-2.412-1.38L13.27 26.626c-.689 1.034 0 2.757 1.38 2.757h7.238c.345 0 .477.371.345.69-1.724 4.136-3.792 11.03-3.792 11.03-.488 1.82 1.283 2.509 2.516 1.275l14.52-16.346c.689-1.034.084-2.853-1.38-2.853h-6.694c-.571 0-.804-.198-.615-.764 1.379-4.137 3.863-11.55 3.863-11.55"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInstantPayGraySmall);
export default ForwardRef;
